import React, { useContext, useEffect, useRef, useState } from 'react';
import { useAtom, atom } from 'jotai';
import {
    highCostAtom,
    highCostAtomShownAlerts,
    highCostAlertsAtom,
    highCostAlertsAtomShownAlerts,
    clarificationsAtom,
    clarificationsAtomShownAlerts,
    priorAuthAtom,
    priorAuthAtomShownAlerts,
    nonCoveredAtom,
    nonCoveredAtomShownAlerts,
    therapeuticIntAtom,
    therapeuticIntAtomShownAlerts,
    admissionMedsAtom,
    admissionMedsAtomShownAlerts,
    pumpPickupAtomShownAlerts,
    refillTooSoonAtomShownAlerts,
    narcoticsRefillAtomShownAlerts,
    alfNewScriptAtom,
    alfCostResponseAtom,
    unavailableMedicationAlertsAtom,
} from '../jotai-atoms/AlertAtoms';
import {
    archivedHighCostAtom,
    archivedHighCostAlertsAtom,
    archivedClarificationsAtom,
    archivedPriorAuthAtom,
    archivedNonCoveredAtom,
    archivedTherapeuticIntAtom,
    archivedAdmissionMedsAtom,
    archivedRefillTooSoonAtom,
    archivedNarcoticsRefillAtom,
    archivedPumpPickupAtom,
} from '../jotai-atoms/ArchivedAlertAtoms';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { UserContext } from '../contexts/UserContext';
import { toast } from 'react-toastify';
import { ActiveAlertContext } from '../contexts/ActiveAlertContext';

const useUpdateAlert = () => {
    const [highCostShownAlerts, setHighCostShownAlerts] = useAtom(highCostAtomShownAlerts);
    const [highCostAlertsShownAlerts, setHighCostAlertsShownAlerts] = useAtom(highCostAlertsAtomShownAlerts);
    const [clarificationsShownAlerts, setClarificationsShownAlerts] = useAtom(clarificationsAtomShownAlerts);
    const [priorAuthShownAlerts, setPriorAuthShownAlerts] = useAtom(priorAuthAtomShownAlerts);
    const [nonCoveredShownAlerts, setNonCoveredShownAlerts] = useAtom(nonCoveredAtomShownAlerts);
    const [therapeuticIntShownAlerts, setTherapeuticIntShownAlerts] = useAtom(therapeuticIntAtomShownAlerts);
    const [admissionMedsShownAlerts, setAdmissionMedsShownAlerts] = useAtom(admissionMedsAtomShownAlerts);
    const [pumpPickupShownAlerts, setPumpPickupShownAlerts] = useAtom(pumpPickupAtomShownAlerts);
    const [refillTooSoonShownAlerts, setRefillTooSoonShownAlerts] = useAtom(refillTooSoonAtomShownAlerts);
    const [narcoticsRefillShownAlerts, setNarcoticsRefillShownAlerts] = useAtom(narcoticsRefillAtomShownAlerts);
    const [alfNewScriptAlerts, setAlfNewScriptAlerts] = useAtom(alfNewScriptAtom);
    const [alfCostResponseAlerts, setAlfCostResponseAlerts] = useAtom(alfCostResponseAtom);
    const [unavailableMedicationAlerts, setUnavailableMedicationAlerts] = useAtom(unavailableMedicationAlertsAtom);

    const [archivedHighCostAlerts, setArchivedHighCostAlerts] = useAtom(archivedHighCostAtom);
    const [archivedHighCostAlertsAlerts, setArchivedHighCostAlertsAlerts] = useAtom(archivedHighCostAlertsAtom);
    const [archivedNonCoveredAlerts, setArchivedNonCoveredAlerts] = useAtom(archivedNonCoveredAtom);
    const [archivedClarificationsAlerts, setArchivedClarificationsAlerts] = useAtom(archivedClarificationsAtom);
    const [archivedPriorAuthAlerts, setArchivedPriorAuthAlerts] = useAtom(archivedPriorAuthAtom);
    const [archivedTherapeuticIntAlerts, setArchivedTherapeuticIntAlerts] = useAtom(archivedTherapeuticIntAtom);
    const [archivedAdmissionMedsAlerts, setArchivedAdmissionMedsAlerts] = useAtom(archivedAdmissionMedsAtom);
    const [archivedRefillTooSoonAlerts, setArchivedRefillTooSoonAlerts] = useAtom(archivedRefillTooSoonAtom);
    const [archivedNarcoticsRefillAlerts, setArchivedNarcoticsRefillAlerts] = useAtom(archivedNarcoticsRefillAtom);
    const [archivedPumpPickupAlerts, setArchivedPumpPickupAlerts] = useAtom(archivedPumpPickupAtom);

    const { faciToken, setFaciToken } = useContext(UserContext);

    const { activeAlert, setActiveAlert } = useContext(ActiveAlertContext);

    function updateReadStatus(readStatus, alert, category) {
        console.log({ readStatus, alert, category });

        const updateReadItem = (prevState) => {
            let tempAlerts = [...prevState];

            tempAlerts = tempAlerts.filter((exisitingAlert) => exisitingAlert._internalID !== alert._internalID);

            alert.readByFaci = readStatus;

            tempAlerts.push(alert);
            return tempAlerts;
        }

        const updateReadAlertItem = (prevState) => {
            let tempAlerts = [...prevState];

            tempAlerts = tempAlerts.filter((exisitingAlert) => exisitingAlert.id !== alert.id);

            alert.readByFaci = readStatus;

            tempAlerts.push(alert);
            return tempAlerts;
        }

        switch (category) {
            case 'highCost':
                setHighCostShownAlerts(updateReadItem);
                break;
            case 'highcostalerts':
                setHighCostAlertsShownAlerts(updateReadItem);
                break;
            case 'clarifications':
                setClarificationsShownAlerts(updateReadItem);
                break;
            case 'openbatch':
                setClarificationsShownAlerts(updateReadItem);
                break;
            case 'priorAuth':
                setPriorAuthShownAlerts(updateReadItem);
                break;
            case 'nonCovered':
                setNonCoveredShownAlerts(updateReadItem);
                break;
            case 'therapeuticInt':
                setTherapeuticIntShownAlerts(updateReadItem);
                break;
            case 'admissionMeds':
                setAdmissionMedsShownAlerts(updateReadItem);
                break;
            case 'pumpPickup':
                setPumpPickupShownAlerts(updateReadItem);
                break;
            case 'narcoticsRefill':
                setNarcoticsRefillShownAlerts(updateReadItem);
                break;
            case 'alfNewScript':
                setAlfNewScriptAlerts((prev) => ({
                    ...prev,
                    alertData: prev.alertData.map((a) =>
                        (a.rxGuid && alert.rxGuid && a.rxGuid === alert.rxGuid) || a._internalID === alert._internalID
                            ? { ...a, readByFaci: readStatus }
                            : a
                    ),
                }));
                if (activeAlert?.alert && (activeAlert.alert.rxGuid === alert.rxGuid || activeAlert.alert._internalID === alert._internalID)) {
                    setActiveAlert({
                        ...activeAlert,
                        alert: { ...activeAlert.alert, readByFaci: readStatus },
                    });
                }
                break;
            case 'alfCostResponse':
                setAlfCostResponseAlerts((prev) => ({
                    ...prev,
                    alertData: prev.alertData.map((a) =>
                        (a.rxGuid && alert.rxGuid && a.rxGuid === alert.rxGuid) || a._internalID === alert._internalID
                            ? { ...a, readByFaci: readStatus }
                            : a
                    ),
                }));
                if (activeAlert?.alert && (activeAlert.alert.rxGuid === alert.rxGuid || activeAlert.alert._internalID === alert._internalID)) {
                    setActiveAlert({
                        ...activeAlert,
                        alert: { ...activeAlert.alert, readByFaci: readStatus },
                    });
                }
                break;
            case 'refillTooSoon':
                setRefillTooSoonShownAlerts(updateReadItem);
                break;
            case 'unavailableMedicationAlerts':
                setUnavailableMedicationAlerts((prev) => ({
                    ...prev,
                    alertData: prev.alertData.map((a) =>
                        (a.rxGuid && alert.rxGuid && a.rxGuid === alert.rxGuid) || a._internalID === alert._internalID
                            ? { ...a, readByFaci: readStatus }
                            : a
                    ),
                }));
                if (activeAlert?.alert && (activeAlert.alert.rxGuid === alert.rxGuid || activeAlert.alert._internalID === alert._internalID)) {
                    setActiveAlert({
                        ...activeAlert,
                        alert: { ...activeAlert.alert, readByFaci: readStatus },
                    });
                }
                break;
        }


    };

    function updateArchivedReadStatus(readStatus, alert, category) {

        const updateArchivedReadItem = (prevState) => {
            let tempAlerts = [...prevState.alertData];

            tempAlerts = tempAlerts.filter((exisitingAlert) => exisitingAlert._internalID !== alert._internalID);

            alert.readByFaci = readStatus;

            tempAlerts.push(alert);
            return {
                ...prevState,
                alertData: tempAlerts,
            };
        }

        switch (category) {
            case 'highCost':
                setArchivedHighCostAlerts(updateArchivedReadItem);
                break;
            case 'highcostalerts':
                setArchivedHighCostAlertsAlerts(updateArchivedReadItem);
                break;
            case 'clarifications':
                setArchivedClarificationsAlerts(updateArchivedReadItem);
                break;
            case 'priorAuth':
                setArchivedPriorAuthAlerts(updateArchivedReadItem);
                break;
            case 'nonCovered':
                setArchivedNonCoveredAlerts(updateArchivedReadItem);
                break;
            case 'therapeuticInt':
                setArchivedTherapeuticIntAlerts(updateArchivedReadItem);
                break;
            case 'admissionMeds':
                setArchivedAdmissionMedsAlerts(updateArchivedReadItem);
                break;
            case 'refillTooSoon':
                setArchivedRefillTooSoonAlerts(updateArchivedReadItem);
                break;
            case 'narcoticsRefill':
                setArchivedNarcoticsRefillAlerts(updateArchivedReadItem);
                break;
            case 'pumpPickup':
                setArchivedPumpPickupAlerts(updateArchivedReadItem);
                break;
        }


    }

    function updateMessageReadStatus(readStatus, action, alert, category) {
        console.log({ readStatus, action, alert, category });

        const updateActionReadStatus = (prevState) => {
            let tempAlerts = [...prevState];

            tempAlerts = tempAlerts.filter((exisitingAlert) => exisitingAlert._internalID !== alert._internalID);

            const matchingAction = alert.requestedActions?.find((x) => x.requestActionID === action.requestActionID);
            if (matchingAction) matchingAction.readByFaci = readStatus;

            tempAlerts.push(alert);
            console.log('updated ' + action.requestActionID);
            return tempAlerts;
        }

        switch (category) {
            case 'highCost':
                setHighCostShownAlerts(updateActionReadStatus);
                break;
            case 'highcostalerts':
                setHighCostAlertsShownAlerts(updateActionReadStatus);
                break;
            case 'admissionMeds':
                setAdmissionMedsShownAlerts(updateActionReadStatus);
                break;
            case 'clarifications':
                setClarificationsShownAlerts(updateActionReadStatus);
                break;
            case 'priorAuth':
                setPriorAuthShownAlerts(updateActionReadStatus);
                break;
            case 'nonCovered':
                setNonCoveredShownAlerts(updateActionReadStatus);
                break;
            case 'therapeuticInt':
                setTherapeuticIntShownAlerts(updateActionReadStatus);
                break;
            case 'refillTooSoon':
                setRefillTooSoonShownAlerts(updateActionReadStatus);
                break;
            case 'narcoticsRefill':
                setNarcoticsRefillShownAlerts(updateActionReadStatus);
                break;
            case 'alfNewScript':
                setAlfNewScriptAlerts((prev) => ({
                    ...prev,
                    alertData: prev.alertData.map((a) => {
                        const isMatch =
                            (a.rxGuid && alert.rxGuid && a.rxGuid === alert.rxGuid) ||
                            a._internalID === alert._internalID;
                        if (!isMatch) return a;
                        return {
                            ...a,
                            requestedActions: (a.requestedActions || []).map((x) =>
                                x.requestActionID === action.requestActionID ? { ...x, readByFaci: readStatus } : x
                            ),
                        };
                    }),
                }));
                if (activeAlert?.alert) {
                    const match =
                        (activeAlert.alert.rxGuid && alert.rxGuid && activeAlert.alert.rxGuid === alert.rxGuid) ||
                        activeAlert.alert._internalID === alert._internalID;
                    if (match) {
                        setActiveAlert({
                            ...activeAlert,
                            alert: {
                                ...activeAlert.alert,
                                requestedActions: (activeAlert.alert.requestedActions || []).map((x) =>
                                    x.requestActionID === action.requestActionID ? { ...x, readByFaci: readStatus } : x
                                ),
                            },
                        });
                    }
                }
                break;
            case 'alfCostResponse':
                setAlfCostResponseAlerts((prev) => ({
                    ...prev,
                    alertData: prev.alertData.map((a) => {
                        const isMatch =
                            (a.rxGuid && alert.rxGuid && a.rxGuid === alert.rxGuid) ||
                            a._internalID === alert._internalID;
                        if (!isMatch) return a;
                        return {
                            ...a,
                            requestedActions: (a.requestedActions || []).map((x) =>
                                x.requestActionID === action.requestActionID ? { ...x, readByFaci: readStatus } : x
                            ),
                        };
                    }),
                }));
                if (activeAlert?.alert) {
                    const match =
                        (activeAlert.alert.rxGuid && alert.rxGuid && activeAlert.alert.rxGuid === alert.rxGuid) ||
                        activeAlert.alert._internalID === alert._internalID;
                    if (match) {
                        setActiveAlert({
                            ...activeAlert,
                            alert: {
                                ...activeAlert.alert,
                                requestedActions: (activeAlert.alert.requestedActions || []).map((x) =>
                                    x.requestActionID === action.requestActionID ? { ...x, readByFaci: readStatus } : x
                                ),
                            },
                        });
                    }
                }
                break;
            case 'pumpPickup':
                setPumpPickupShownAlerts(updateActionReadStatus);
                break;
            case 'unavailableMedicationAlerts':
                setUnavailableMedicationAlerts((prev) => ({
                    ...prev,
                    alertData: prev.alertData.map((a) => {
                        const isMatch =
                            (a.rxGuid && alert.rxGuid && a.rxGuid === alert.rxGuid) ||
                            a._internalID === alert._internalID;
                        if (!isMatch) return a;
                        return {
                            ...a,
                            requestedActions: (a.requestedActions || []).map((x) =>
                                x.requestActionID === action.requestActionID ? { ...x, readByFaci: readStatus } : x
                            ),
                        };
                    }),
                }));
                if (activeAlert?.alert) {
                    const match =
                        (activeAlert.alert.rxGuid && alert.rxGuid && activeAlert.alert.rxGuid === alert.rxGuid) ||
                        activeAlert.alert._internalID === alert._internalID;
                    if (match) {
                        setActiveAlert({
                            ...activeAlert,
                            alert: {
                                ...activeAlert.alert,
                                requestedActions: (activeAlert.alert.requestedActions || []).map((x) =>
                                    x.requestActionID === action.requestActionID ? { ...x, readByFaci: readStatus } : x
                                ),
                            },
                        });
                    }
                }
                break;
        }
    }
    return {
        updateReadStatus,
        updateArchivedReadStatus,
        updateMessageReadStatus,
    };
};

export default useUpdateAlert;
